import React, { useState } from 'react';
import Closeicon from '../../images/Closeicon';
import { ChatState } from '../../Context/ChatProvider';
import { infoData } from './../../utils/constants';

const InfoModal = ({ isOpen, onClose }) => {
  const [activeIndex, setActiveIndex] = useState(null);
    const {setInfoIsOpen} = ChatState();
  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="modalContent" onClick={onClose}>
      <section className="modal_section" onClick={(e) => e.stopPropagation()}>
        <button className='buttonClose' type='button' aria-label='Close' onClick={()=>setInfoIsOpen(false)} ><Closeicon /></button>
        <header>
          <h2>Information and security</h2>
        </header>

        <div className="accordion">
          {infoData.map((item, index) => (
            <div key={index} className="accordion-item">
              <div 
                className={`accordion-title ${activeIndex === index ? 'active' : ''}`} 
                onClick={() => toggleAccordion(index)}
              >
                {item.title}
                <span>{activeIndex === index ? '<' : '>'}</span>
              </div>
              {activeIndex === index && (
                <div className="accordion-body">
                  <div>{item.content}</div>
                </div>
              )}
            </div>
          ))}
        </div>
        <div className=" buttons_yes_no">
            <button className="button" onClick={()=>setInfoIsOpen(false)} >Cancel</button>
        </div>
        <footer style={{ marginTop: '20px', fontSize: '12px', opacity: 0.7 }}>
          App version: 1.0.2 (Build: 2026)
        </footer>
      </section>
    </div>
  );
};

export default InfoModal;